import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {NzModalRef} from 'ng-zorro-antd/modal';
import {AppUtils} from '../../../../core/config/app.utils';
import {SETTINGS} from "../../../../core/config/common.settings";
import {OpenAiService} from "../../../../core/services/open-ai.service";
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-add-description',
  templateUrl: './add-description.component.html',
  styleUrls: ['./add-description.component.scss'],
})
export class AddDescriptionComponent implements OnInit {
  @Input() description?: string;
  @Input() keyword?: string;
  @Input() contentType?: string;
  @Input() queryData?: any;
  @Input() descriptionType?: string;
  descriptionForm: any;
  formErrors: any;
  isData = false;
  chatKeywords: string[] = [];
  minWords = 80;
  maxWords = 100;
  isLoading = false;

  constructor(private fb: FormBuilder, private modal: NzModalRef,
              private openAiService: OpenAiService,
              private translocoService: TranslocoService) {
    this.formErrors = {
      body: {},
      keyword: {}
    };
  }

  ngOnInit(): void {
    this.minWords = this.descriptionType === "experiences" ? 40 : 80;
    this.maxWords = this.descriptionType === "experiences" ? 80 : 100;
    this.descriptionForm = this.fb.group({
      keyword: [this.keyword || '', [Validators.required]],
      body: [this.description || '', [Validators.required]],
    });
    this.descriptionForm.valueChanges.subscribe((form: any) => {
      this.formErrors = AppUtils.getFormErrors(
        this.descriptionForm,
        this.formErrors
      );
    });
  }

  private async getGeneratedContent(payload: any): Promise<any> {
    try {
      return await this.openAiService.askChatGPT({query: payload});
    } catch (error) {

    }
  }

  private breakdownAndPatchContent(text: string): void {
    // breakdown the spaces
    const lines = text.split('\n');

    const contentLines: string[] = [];
    const tags: string[] = [];

    // Loop through each line
    lines.forEach(line => {
      const trimmedLine = line.trim();
      if (trimmedLine.startsWith('#')) {
        // Split by whitespace to handle multiple tags separated by spaces
        const lineTags = trimmedLine.split(/\s+/).map(tag => tag.substring(1));
        tags.push(...lineTags);
      } else {
        contentLines.push(line);
      }
    });

    // Join content lines into a single string
    const content = contentLines.join(' ').trim();

    // Join tags array into a comma-separated string
    const tagsString = tags.join(', ');

    this.descriptionForm.patchValue({body: content, keyword: tagsString});
    this.isData = true;
  }


  reGenerate(): void {
    this.isLoading = true;
    if (this.contentType === SETTINGS.CONTENT_TYPES.GENERATED) {
      if (this.descriptionType === "experiences") {
        const payload = `Generate a captivating description of '${this.queryData.name}' between '${this.minWords} - ${this.maxWords}'
        words in '${this.queryData.language}',starting with a unique word that has not been used before. Incorporate the keywords:  '${this.chatKeywords
    .map(k => k)
    .join(", ")}', etc. Highlight key aspects that make the experience memorable and enticing.
        Provide only one tag describes the best for the generated content Tag should start with # and tag should be in english no matter what language it is(tags should be always present, very important).`;
        this.getGeneratedContent(payload).then(value => {
          this.breakdownAndPatchContent(value.choices[0].message.content);
          this.isLoading = false;
        });
      } else {
        const payload = `Generate a captivating description of '${this.queryData.name}' between '${this.minWords} - ${this.maxWords}'
        words in '${this.queryData.language}',starting with a unique word that has not been used before. Incorporate the keywords:  '${this.chatKeywords
          .map(k => k)
          .join(", ")}', etc. Highlight aspects like local culture, delicious food, and stunning scenic spots, creating an engaging and travel-inspiring tone to entice visitors.
        Provide only one tag describes the best for the generated content Tag should start with # and tag should be in english no matter what language it is(tags should be always present, very important).`;
        this.getGeneratedContent(payload).then(value => {
          this.breakdownAndPatchContent(value.choices[0].message.content);
          this.isLoading = false;
        });
      }
    }
  }

  submit(): any {
    if (this.descriptionForm.invalid) {
      return;
    }
    if (this.contentType === SETTINGS.CONTENT_TYPES.GENERATED) {
      this.modal.close({...this.descriptionForm.getRawValue(), type: this.SETTINGS.CONTENT_TYPES.GENERATED});
    }

    if (this.contentType === SETTINGS.CONTENT_TYPES.TYPED) {
      this.modal.close({...this.descriptionForm.getRawValue(), type: this.SETTINGS.CONTENT_TYPES.TYPED});
    }
  }

  protected readonly SETTINGS = SETTINGS;
}
